import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToastStyles.css';
import useAuth from './useAuth';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';

function Add_Fuel_Form() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();
    const [vehicleModals, setVehicleModals] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [fuelTypes, setFuelTypes] = useState([]);
    const [flashAlert, setFlashAlert] = useState(null);
    const [flashAlert1, setFlashAlert1] = useState(null);
    const [flashAlert2, setFlashAlert2] = useState(null);
    const [error, setError] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [uploadError, setUploadError] = useState("");
    const [Grade, setGrade] = useState('');
    const [loading, setLoading] = useState(true);
    const [responseMessage, setResponseMessage] = useState('');
    const Loader = () => (
        <div className="loader-container1">
            <div className="spinner1"></div>
            <p>Loading...</p>
        </div>
    );
    const [formData, setFormData] = useState({
        comp_name: '',
        emp_code: '',
        grade: '',
        dept_name: '',
        designation_name: '',
        report_mngr: '',
        mode_of_travel: '',
        to_city: '',
        guesthouse: '',
        bank_acnum: '',
        bank_name: '',
        ifsc_code: '',
        total_fuel_amt: '',
        total_fuel_qty: '',
        img: []  // To store the image files
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitAllowed, setIsSubmitAllowed] = useState(true);
    const [transportRows, setTransportRows] = useState([{
        id: 1,
        dated: '',
        vehicle_number: '',
        vehicle_make: '',
        vehicle_modal: '',
        vehicle_type: '',
        fuel_type: '',
        fuel_unit: '',
        fuel_rate: '',
        fuel_quantity: '',
        fuel_amount: '',
        fixed_amount: '',
        meter_reading: '',
        receipt: [], // To store the image files
        meter_reading_image: []
    }]);

    useAuth();  // Custom hook for authentication

    const handleBackClick = () => {
        navigate("/manage_fuel_forms");
    };

    const handleAddTransportRow = () => {
        setTransportRows([
            ...transportRows,
            {
                id: transportRows.length + 1, dated: '', vehicle_number: '',
                vehicle_make: '', vehicle_modal: '', vehicle_type: '', fuel_type: '',
                fuel_unit: '', fuel_rate: '', fuel_quantity: '', fuel_amount: '', fixed_amount: '',meter_reading: '',receipt: [] ,meter_reading_image: []
            }
        ]);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };


    // fetch vehicle modals
    const fetchVehicleModals = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleModels`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleModals(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            // setLoading(false);
        }
    };

    // fetch vehicle types
    const fetchVehicleTypes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleTypes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleTypes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            //  setLoading(false);
        }
    };

    // fetch vehicle numbers
    const fetchVehicleNumbers = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleNumbers`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleNumbers(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            //  setLoading(false);
        }
    };

    // fetch fuel types
    const fetchFuelTypes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getFuelTypes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setFuelTypes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            // setLoading(false);
        }
    };

    // fetch vehicle makes
    const fetchVehicleMakes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleMakes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleMakes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            // setLoading(false);
        }
    };

    useEffect(() => {
        const loadAllData = async () => {
            try {
                await Promise.all([
                    fetchVehicleTypes(),
                    fetchVehicleModals(),
                    fetchVehicleNumbers(),
                    fetchFuelTypes(),
                    fetchVehicleMakes()
                ]);
            } catch (error) {
                console.error('Error loading data:', error);
            } finally {
                //  setLoading(false);
            }
        };

        loadAllData();
    }, [navigate]);



    const handleTransportChange = async (index, e) => {
        const { name, value, type, files, id } = e.target;
        const newTransportRows = [...transportRows];        
        newTransportRows[index] = { ...newTransportRows[index], [name]: value };
       

        const MAX_SIZE = 1 * 1024 * 1024; // 1MB in bytes

        // If the input type is 'file' and there are selected files
        if (type === 'file' && files.length > 0) {
            const file = files[0]; // Get the first selected file
    
            if (file.type === 'application/pdf') {
                // Directly store PDF file without resizing
                newTransportRows[index] = { ...newTransportRows[index], [name]: file };
            } else {
                try {
                    const resizedFile = await resizeImage(file, 1024, 1024, 1); // Resize only images
                    newTransportRows[index] = { ...newTransportRows[index], [name]: resizedFile };
                } catch (error) {
                    toast.error(error.message);
                    return;
                }
            }
        } else {
            newTransportRows[index] = { ...newTransportRows[index], [name]: value };
        }


         // Update  
         if (name === 'vehicle_number') {
            // newTransportRows[index].fuel_amount = newTransportRows[index].fuel_rate * newTransportRows[index].fuel_quantity;
            const vehicle = vehicleNumbers.find(vehicle => vehicle.vehicle_number === value);
            if (vehicle) {
                newTransportRows[index].vehicle_modal = vehicle.vehicle_modal; 
                newTransportRows[index].vehicle_type = vehicle.vehicle_type;
                newTransportRows[index].fuel_type = vehicle.fuel_type;
                newTransportRows[index].fuel_unit = vehicle.fuel_unit;
                newTransportRows[index].fuel_quantity = 0;
            } else {
                newTransportRows[index].vehicle_modal = '';               
                newTransportRows[index].vehicle_type = '';
                newTransportRows[index].fuel_type = '';
                newTransportRows[index].fuel_unit = '';
                newTransportRows[index].fuel_quantity = 0;
            } 
        }

          

         // Update fuel amount when rate or quantity changes (if both are present and quantity is not 0)
         if (name === 'fuel_rate' || name === 'fuel_quantity') {
            // Calculate the fuel amount based on rate and quantity
            const rate = parseFloat(newTransportRows[index].fuel_rate) || 0;
            const quantity = parseFloat(newTransportRows[index].fuel_quantity) || 0;
            newTransportRows[index].fuel_amount = rate * quantity;
            //execute after completing above
        }

        if (parseFloat(newTransportRows[index].fuel_quantity) === 0) {
            // If quantity is 0, fuel_amount can be manually entered
            if (name === 'fuel_amount') {
                newTransportRows[index].fuel_amount = parseFloat(value) || 0;
            } 
            // else {
            //     newTransportRows[index].fuel_amount = '';
            // }
        } else {
            // If quantity is not 0, calculate fuel_amount automatically
            const rate = parseFloat(newTransportRows[index].fuel_rate) || 0;
            const quantity = parseFloat(newTransportRows[index].fuel_quantity) || 0;
            newTransportRows[index].fuel_amount = rate * quantity;
        }
        

      
        // Update the transport rows state
        setTransportRows(newTransportRows);
    };

    const resizeImage = (file, maxWidth, maxHeight, maxSizeMB) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
    
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
    
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    let width = img.width;
                    let height = img.height;
    
                    // Maintain aspect ratio while resizing
                    if (width > maxWidth || height > maxHeight) {
                        if (width > height) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        } else {
                            width *= maxHeight / height;
                            height = maxHeight;
                        }
                    }
    
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
    
                    // Convert canvas to Blob and check size
                    canvas.toBlob((blob) => {
                        if (blob.size > maxSizeMB * 1024 * 1024) {
                            reject(new Error(`Resized file still exceeds ${maxSizeMB}MB.`));
                        } else {
                            resolve(new File([blob], file.name, { type: file.type }));
                        }
                    }, file.type, 0.8); // Adjust quality (0.8 = 80%)
                };
            };
    
            reader.onerror = (error) => reject(error);
        });
    };
    


    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        const processedFiles = [];
    
        for (const file of files) {
            if (file.type === 'application/pdf') {
                // Directly add PDF without resizing
                processedFiles.push(file);
            } else {
                try {
                    const resizedFile = await resizeImage(file, 1024, 1024, 1); // Resize only images
                    processedFiles.push(resizedFile);
                } catch (error) {
                    toast.error(error.message);
                }
            }
        }
    
        if (processedFiles.length > 0) {
            setFormData(prevData => ({
                ...prevData,
                img: processedFiles // Store both images & PDFs
            }));
        }
    };
    
       


    const handleRemoveTransportRow = (index) => {
        if (transportRows.length > 1) {
            setTransportRows(transportRows.filter((_, i) => i !== index));
        }
    };



    useEffect(() => {
        const fetchProfileData = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}profile`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("Profile data:", result); // Log to check fetched data

                if (result.status) {
                    const { profile  } = result;

                    // Set default values from profile
                    setEmpCode(profile.emp_code || '');
                    setGrade(profile.grade || '');
                    setFormData(prevData => ({
                        ...prevData,
                        comp_name: profile.comp_name || '',
                        emp_code: profile.emp_code || '',
                        dept_name: profile.dept_name || '',
                        designation_name: profile.designation_name || '',
                        grade: profile.grade || '',
                        report_mngr: profile.report_mngr || '',
                        mobile: profile.mobile || '', // Do not display the password
                        bank_acnum: profile.bank_acnum || '',
                        bank_name: profile.bank_name || '',
                        ifsc_code: profile.ifsc_code || '',
                        location_name: profile.location_name || '',
                    }));
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    // Calculate the total amount
    // const calculateTotal = () => {
    //     return transportRows.reduce((total, row) => total + (parseFloat(row.fuel_amount) || 0), 0);
    // };

    const calculateTotal = () => {
         // Calculate the total amount, make total of all total_fuel_amt rows
            const total_amt = transportRows.reduce((total, row) => total + (parseFloat(row.fuel_amount) || 0), 0);
            return total_amt
            //update formData
            // setFormData(prevState => ({
            //     ...prevState,
            //     total_fuel_amt: total_amt
            // }));

    };


    // Calculate the total quantity
    // const calculateTotalQuantity = () => {
    //     return transportRows.reduce((total, row) => total + (parseFloat(row.fuel_quantity) || 0), 0);
    // };

    const calculateTotalQuantity = () => {
        const total_qty = transportRows.reduce((total, row) => total + (parseFloat(row.fuel_quantity) || 0), 0);
        return total_qty
        //update formData
        // setFormData(prevState => ({
        //     ...prevState,
        //     total_fuel_qty: total_qty
        // }));
    };

    const calculateTotalFixed = () => {
        const total_fixed = transportRows.reduce((total, row) => total + (parseFloat(row.fixed_amount) || 0), 0);
        return total_fixed
        //update formData
        // setFormData(prevState => ({
        //     ...prevState,
        //     total_fuel_qty: total_qty
        // }));
    };

     useEffect(() => {
            calculateTotal();
            calculateTotalQuantity();
            calculateTotalFixed();
        }, [transportRows]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isSubmitAllowed) {
            toast.error("Please fix the file size errors before submitting.");
            return;
        }
        if (isSubmitting) return;
        setIsSubmitting(true);
    
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('comp_name', formData.comp_name);
            formDataToSend.append('emp_code', formData.emp_code);
            formDataToSend.append('grade', formData.grade);
            formDataToSend.append('dept_name', formData.dept_name);
            formDataToSend.append('designation_name', formData.designation_name);
            formDataToSend.append('mobile', formData.mobile);
            formDataToSend.append('report_mngr', formData.report_mngr);
            formDataToSend.append('mode_of_travel', formData.mode_of_travel);
            formDataToSend.append('to_city', formData.to_city);
            formDataToSend.append('guesthouse', formData.guesthouse);
            formDataToSend.append('bank_acnum', formData.bank_acnum);
            formDataToSend.append('bank_name', formData.bank_name);
            formDataToSend.append('ifsc_code', formData.ifsc_code);
            formDataToSend.append('location_name', formData.location_name);
            formDataToSend.append('total_fuel_amt', calculateTotal());
            formDataToSend.append('total_fuel_qty', calculateTotalQuantity());
            formDataToSend.append('total_fixed', calculateTotalFixed());
            // Append the image files
            formData.img.forEach((file, index) => {
                formDataToSend.append(`img[${index}]`, file);
            });

    
            transportRows.forEach((row, index) => {
                Object.keys(row).forEach((key) => {
                    if (key === 'receipt' && row[key]) {
                        formDataToSend.append(`transportRows[${index}][${key}]`, row[key]);
                    } else {
                        formDataToSend.append(`transportRows[${index}][${key}]`, row[key]);
                    }
                });
            });
            transportRows.forEach((row, index) => {
                Object.keys(row).forEach((key) => {
                    if (key === 'meter_reading_image' && row[key]) {
                        formDataToSend.append(`transportRows[${index}][${key}]`, row[key]);
                    } else {
                        formDataToSend.append(`transportRows[${index}][${key}]`, row[key]);
                    }
                });
            });
    
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}addFuelForm`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formDataToSend // Send as FormData, not JSON
            });
    
            const result = await response.json();
            if (result.status) {
                toast.success('Fuel Form submitted successfully!');
                setTimeout(() => {
                    navigate('/edit_fuel_form/' + result.id);
                }, 2000);
            } else {
                toast.error(result.message || 'An error occurred while submitting the form.');
            }
        } catch (error) {
            console.error('Submission error:', error);
            toast.error('Failed to submit form');
        } finally {
            setIsSubmitting(false);
        }
    };

   

    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0" style={{ fontSize: '20px' }}>Add New Fuel Form</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                        <li className="breadcrumb-item active">New Fuel Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader /> // Show loader if loading is true
                    ) : (
                        <>
                            <section className="col-lg-12">
                                <div className="card" style={{ borderTop: '3px solid #CC5500' }}>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit} method="post" acceptCharset="utf-8">
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <div className="box-body">
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="emp_code"
                                                                    id="name"
                                                                    value={formData.emp_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Employee No/Consultant"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Name </label>
                                                                <input
                                                                    type="text"
                                                                    name="comp_name"
                                                                    id="name"
                                                                    value={formData.comp_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Name"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee Band</label>
                                                                <input
                                                                    type="text"
                                                                    name="grade"
                                                                    id="name"
                                                                    value={formData.grade}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Department</label>
                                                                <input
                                                                    type="text"
                                                                    name="dept_name"
                                                                    id="name"
                                                                    value={formData.dept_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Designation </label>
                                                                <input
                                                                    type="text"
                                                                    name="designation_name"
                                                                    id="name"
                                                                    value={formData.designation_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Mobile No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="mobile"
                                                                    id="name"
                                                                    value={formData.mobile}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_name">Bank Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_name"
                                                                    id="bank_name"
                                                                    value={formData.bank_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_acnum">Bank Ac.No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_acnum"
                                                                    id="bank_acnum"
                                                                    value={formData.bank_acnum}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="ifsc_code">IFSC Code
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="ifsc_code"
                                                                    id="ifsc_code"
                                                                    value={formData.ifsc_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Reporting Manager
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="report_mngr"
                                                                    id="name"
                                                                    value={formData.report_mngr}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Location
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="location_name"
                                                                    id="name"
                                                                    value={formData.location_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <center>
                                                    <span className="btn btn-warning" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                        Details of Fuel Form
                                                    </span>
                                                </center>

                                                <div className="transport-table-container mb-3 text-right">
                                                    <button type="button" onClick={handleAddTransportRow} className="btn btn-sm btn-primary">+</button>

                                                    {/* Responsive Table Wrapper */}
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <td colSpan="12"></td>
                                                                </tr>
                                                                <tr className="header-row text-center">
                                                                    <th>Date<span className="text-danger">*</span></th>
                                                                    <th>Vehicle Number<span className="text-danger">*</span></th>
                                                                    <th>Type</th>                                                                   
                                                                    <th>Model</th>
                                                                    <th>Fuel</th>
                                                                    <th>Fuel Unit</th>
                                                                    <th>Fuel Rate<span className="text-danger">*</span></th>
                                                                    <th>Quantity<span className="text-danger">*</span></th>
                                                                    <th>Total</th>
                                                                    <th>Fixed Amount</th>
                                                                    <th>Meter Reading</th>
                                                                    <th>Meter Reading Image</th>
                                                                    <th>Bills Images</th>
                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {transportRows.map((row, index) => (
                                                                    <tr key={index}>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input
                                                                                type="date"
                                                                                name="dated"
                                                                                value={row.dated}
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                                max={new Date().toISOString().split("T")[0]}
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>

                                                                        <input placeholder='Number' list="vm" className='form-control input-font'  name='vehicle_number' id='vehicle_number' 
                                                                            onChange={(e) => handleTransportChange(index, e)} required={index === 0}/>
                                                                            <datalist id="vm">
                                                                                {vehicleNumbers.map((vehicleNumber) => (
                                                                                    <option key={vehicleNumber.id} value={vehicleNumber.vehicle_number}>
                                                                                        {vehicleNumber.vehicle_number}
                                                                                    </option>
                                                                                ))}
                                                                            </datalist>                                                                         
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input className="form-control input-font"
                                                                                type="text"
                                                                                readOnly
                                                                                value={row.vehicle_type}
                                                                                name="vehicle_type"                                                                                
                                                                            />                                                                            
                                                                        </td>
                                                                        <td style={{ minWidth: '20rem' }}>

                                                                        <input className="form-control input-font"
                                                                                type="text"
                                                                                readOnly
                                                                                value={row.vehicle_modal}
                                                                                name='vehicle_modal' id='vehicle_modal'                                                                      
                                                                            />                                                                           
                                                                        </td>
                                                                        
                                                                        <td style={{ minWidth: '6rem' }}>                                                                            
                                                                            <input className="form-control input-font"
                                                                                type="text"
                                                                                readOnly
                                                                                value={row.fuel_type}
                                                                                name='fuel_type' id='fuel_type'                                                                  
                                                                            />    
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>                                                                           
                                                                            <input className="form-control input-font"
                                                                                type="text"
                                                                                readOnly
                                                                                value={row.fuel_unit}
                                                                                name='fuel_unit' id='fuel_unit'   
                                                                                                                                            
                                                                            />    
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}> <input className="form-control input-font"
                                                                            type="number"
                                                                            value={row.fuel_rate}
                                                                            name="fuel_rate"
                                                                            onChange={(e) => handleTransportChange(index, e)}
                                                                        />
                                                                        </td>
                                                                        <td style={{ minWidth: '4rem' }}>
                                                                            <input className="form-control input-font"
                                                                                type="number"
                                                                                value={row.fuel_quantity}
                                                                                name="fuel_quantity"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input
                                                                                className="form-control input-font"
                                                                                type="number"
                                                                                value={row.fuel_amount}
                                                                                required={index === 0}   
                                                                                name="fuel_amount"
                                                                                onChange={(e) => handleTransportChange(index, e)}                                                                                
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '8rem' }}>
                                                                            <input className="form-control input-font"
                                                                                type="number"
                                                                                value={row.fixed_amount}
                                                                                name="fixed_amount"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '8rem' }}>
                                                                            <input className="form-control input-font"
                                                                                type="number"
                                                                                value={row.meter_reading}
                                                                                name="meter_reading"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '12rem' }}>  
                                                                            <input
                                                                            type="file"
                                                                            name="meter_reading_image"
                                                                            id="meter_reading_image"
                                                                            accept=".jpg,.jpeg,.png,.pdf"
                                                                            onChange={(e) => handleTransportChange(index, e)}
                                                                            className="form-control input-font"
                                                                        /> 
                                                                        </td>
                                                                        <td style={{ minWidth: '12rem' }}>  
                                                                            <input
                                                                            type="file"
                                                                            name="receipt"
                                                                            id="receipt"
                                                                            accept=".jpg,.jpeg,.png,.pdf"
                                                                            onChange={(e) => handleTransportChange(index, e)}
                                                                            className="form-control input-font"
                                                                        /> 
                                                                        </td>
                                                                        <td>
                                                                            <button type="button" onClick={() => handleRemoveTransportRow(index)} className="btn btn-sm btn-danger">×</button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <td colSpan="8"><b>Total Fuel Qty: {transportRows.reduce((total, row) => total + (parseFloat(row.fuel_quantity) || 0), 0)}</b></td>
                                                                    <td className="text-right font-weight-bold">
                                                                        Total Amt : ₹ {transportRows.reduce((total, row) => total + (parseFloat(row.fuel_amount) || 0), 0)}
                                                                    </td>
                                                                    <td className="text-right font-weight-bold">
                                                                        Total Fixed Amt : ₹ {transportRows.reduce((total, row) => total + (parseFloat(row.fixed_amount) || 0), 0)}
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </fieldset>


                                            {/* Upload Images Section */}
                                            <section className="col-lg-12">
                                                {uploadError && <div className="alert alert-danger text-center p-2">{uploadError}</div>}

                                                <label className="font-weight-bold">Upload Multiple Images:</label>
                                                <input
                                                    type="file"
                                                    name="img"
                                                    multiple
                                                    accept=".jpg,.jpeg,.png,.pdf"
                                                    onChange={handleFileChange}
                                                    className="form-control mb-3"
                                                />

                                                {/* Buttons */}
                                                <div className="d-flex justify-content-center">
                                                    <button type="submit" className="btn btn-success">
                                                        {isSubmitting ? 'Creating New...' : 'Save'}
                                                    </button>
                                                    <button type="button" className="btn btn-secondary ml-3" onClick={handleBackClick}>
                                                        Cancel
                                                    </button>
                                                </div>
                                            </section>

                                        </form>
                                    </div>
                                </div>
                            </section>
                        </>
                    )}
                </div>
                <Footer />
            </div>
            <ToastContainer />
        </div>
    )
}

export default Add_Fuel_Form